export default "__VITE_ASSET__2PuxvVEp__"